import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ContextChange, DashboardContext, WidgetReference } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/appclient';
import { CarrierCleanupQuery, CarrierCleanupQueryResult, CarrierListEntry, CarrierReplacement } from '../cleanup-administration.model';
import { CleanupAdministrationService } from '../cleanup-administration.service';
import { AbstractWidgetComponent } from '@sdbn/appclient';

@Component({
  selector: 'app-cleanup-administration',
  templateUrl: './cleanup-administration.component.html',
  styleUrls: ['./cleanup-administration.component.scss']
})
export class CleanuupAdministrationComponent extends AbstractWidgetComponent {

  reference: WidgetReference;
  context: DashboardContext;

  carriersToReplace = new Array<CarrierListEntry>();
  carrierListEntries = new Array<CarrierListEntry>();
  dataSource = new MatTableDataSource(new Array<CarrierListEntry>());

  responseMessages: ResponseMessage[];

  loading = false;

  carrierQueryFormGroup = new FormGroup({});
  carrierQueryValid = false;

  carrierReplacementFormGroup = new FormGroup({});
  replaceButtonEnabled = false;

  // @ViewChild(MatSort) sort: MatSort;
  sortDirection = 'asc';
  sortColumn = 'carrier';
  columnsToDisplay = [
    'checkbox', 'carrier', 'count'
  ];

  constructor(
    public translationService: TranslationService,
    private dialog: MatDialog,
    private cleanupAdministrationService: CleanupAdministrationService
  ) {
    super();
    this.carrierQueryFormGroup.addControl('query', new FormControl('', [Validators.required, Validators.minLength(1)]));
    this.carrierQueryFormGroup.valueChanges.subscribe(
      value => {
        if (this.carrierQueryFormGroup.dirty) {
          this.carrierQueryValid = this.carrierQueryFormGroup.valid;
        }
      }
    );

    this.carrierReplacementFormGroup.addControl('replacement', new FormControl('', [Validators.required, Validators.minLength(1)]));
    this.carrierReplacementFormGroup.valueChanges.subscribe(
      value => {
        if (this.carrierReplacementFormGroup.dirty) {
          this.updateReplacementButtonEnabledment();
        }
      }
    );
  }

  private updateReplacementButtonEnabledment() {
    this.replaceButtonEnabled = this.carrierReplacementFormGroup.valid && this.carriersToReplace.length > 0;
  }

  public carrierSelectionChanged() {
    this.carriersToReplace = this.carrierListEntries.filter(c => c.selected);
    this.updateReplacementButtonEnabledment();
  }

  public findCarriersByQuery() {
    this.loading = true;
    this.carrierListEntries = new Array<CarrierListEntry>();
    this.carriersToReplace = new Array<CarrierListEntry>();
    this.dataSource.data = [];

    const query = new CarrierCleanupQuery();
    query.queryString = this.carrierQueryFormGroup.controls.query.value;
    this.cleanupAdministrationService.findCarrierByQuery(query).subscribe(
      result => {
        result.forEach(
          r => {
            this.carrierListEntries.push(new CarrierListEntry(r));
          }
        );
        this.dataSource.data = this.carrierListEntries;
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  public findAndReplace() {

    let countToReplace = 0;

    this.carriersToReplace.forEach(c => countToReplace += c.count);

    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.cleanup-administration.find-and-replace.confirm-dialog.title',
      messageKey: 'tmc-yard.widgets.cleanup-administration.find-and-replace.confirm-dialog.message',
      messageParams: [countToReplace, this.carrierReplacementFormGroup.controls.replacement.value],
      confirm: () => {
        this.loading = true;

        const replacement = new CarrierReplacement();
        replacement.replacement = this.carrierReplacementFormGroup.controls.replacement.value;

        this.carriersToReplace.forEach(
          c => {
            if (c.selected) {
              replacement.carriersToReplace.push(new CarrierCleanupQueryResult(c));
            }
          }
        );
        this.cleanupAdministrationService.replaceCarriers(replacement).subscribe(
          result => {
            this.findCarriersByQuery();
          },
          error => {
            this.loading = false;
          }
        );
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }
}
